import { object, string } from "yup"
import { replaceCanvasWithSvg } from "@utils/dom"
import companyLogo from "@assets/images/S&P_Global_logo.svg"
import DOMPurify from "dompurify"

export const formValidationSchema = object({
  name: string().required("File name field can not be empty"),
})

const hideAllButtons = (updatedHtml: HTMLElement) => {
  const buttons = updatedHtml.querySelectorAll("button")
  buttons.forEach((button) => (button.style.display = "none"))
}

export const createWatermarkedChartImage = async (html: HTMLElement, runReference: string) => {
  const updatedHtml = await replaceCanvasWithSvg(html)
  const logo = getWatermarkLogo()
  const footer = getWatermarkFooter(runReference)

  hideAllButtons(updatedHtml)

  const wrapper = document.createElement("div")

  wrapper.style.position = "relative"
  wrapper.style.display = "inline-flex"
  wrapper.style.flexDirection = "column"
  wrapper.style.backgroundColor = "white"
  wrapper.style.padding = "10px"

  wrapper.append(updatedHtml, logo, footer)

  return wrapper
}

const getWatermarkLogo = () => {
  const logo = document.createElement("img")
  logo.src = companyLogo
  logo.style.position = "absolute"
  logo.style.top = "10px"
  logo.style.right = "10px"
  logo.style.width = "100px"
  logo.style.height = "auto"

  return logo
}

const getWatermarkFooter = (runReference: string) => {
  const footer = document.createElement("div")
  footer.style.width = "100%"
  footer.style.display = "flex"
  footer.style.justifyContent = "space-between"
  footer.style.alignItems = "center"
  footer.style.padding = "0 15px"
  footer.style.boxSizing = "border-box"

  const textLeftTop = document.createElement("div")
  textLeftTop.innerHTML = DOMPurify.sanitize("<strong>S&P Global, Market Intelligence</strong> PGM")
  textLeftTop.style.whiteSpace = "nowrap"

  const textLeftBottom = document.createElement("div")
  textLeftBottom.innerHTML = DOMPurify.sanitize(runReference)
  textLeftBottom.style.fontSize = "10px"
  textLeftBottom.style.color = "grey"

  const textRight = document.createElement("div")
  textRight.innerHTML = DOMPurify.sanitize(`© ${new Date().getFullYear()} S&P Global`)
  textRight.style.whiteSpace = "nowrap"
  textRight.style.fontSize = "17px"

  const textLeft = document.createElement("div")
  textLeft.append(textLeftTop, textLeftBottom)

  footer.append(textLeft, textRight)

  return footer
}
